<template>

  <div id="card-2" class="card border-0">
    <div class="shadow card-rounded  stand-up-animation animation-shadow">
      <m-img :src="image" :alt="alt" class="card-img-top card-rounded"/>
      <div class="card-body">
        <div class="row ">
          <div class="col" data-slot="default">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import mImg from '../Tags/Img'
import {CardProps} from "./CardProps";

export default {
  name: "Card2",
  components: {mImg},
  props: {
    ...CardProps
  }
}
</script>

<style>
#card-2 img {
  object-fit: cover;
  height: 250px;
}
</style>

<style scoped>
.card-rounded {
  border-radius: 15px 15px 0 0;
}

.card {
  height: 100% !important;
  cursor: pointer;
  border-radius: 15px 15px 0 0 !important;
  border: none;
}

.stand-up-animation {
  transform: translateY(0px);
  transition: all 0.3s ease 0s;
}

.stand-up-animation:hover {
  transform: translateY(-7px);
  transition: all 0.3s ease 0s;
}

.animation-shadow:hover {
  box-shadow: 10px 10px 10px rgba(180, 210, 198, 0.4);
}

</style>

